var map = {
	"./02.svg": "7872",
	"./03.svg": "259c",
	"./04.svg": "7ee3",
	"./der_01_aim.svg": "3d27",
	"./der_01_chart.gif": "141d",
	"./der_01_coin.png": "d2f9",
	"./der_01_data.svg": "483f",
	"./der_01_fx.png": "8c8c",
	"./der_01_question-mark.png": "66b5",
	"./der_01_stone.png": "90a6",
	"./der_01_xrobot.png": "ad59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c7f1";